import React, {FunctionComponent, PropsWithChildren} from 'react';
import TextField from '@mui/material/TextField';
import {DatePicker} from '@mui/x-date-pickers';
import {TreatmentListJson} from '../../../api/generated/medical-rest';
import {Button, Checkbox, FormControlLabel, Stack} from "@mui/material";
import {HealthAndSafety, HealthAndSafetyOutlined} from "@mui/icons-material";

export type TreatmentFormProps = PropsWithChildren<TreatmentFormBaseProps & {
    onTimestampChange: (newDate: any) => void;
    onNoteChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onPrivateChange: (isPrivate: boolean) => void;
    treatment: TreatmentListJson;
    hasError?: boolean;
    isPending?: boolean;
}>;

export type TreatmentFormBaseProps = {
    onFormSave: (treatment: TreatmentListJson) => void;
    onFormCancel: () => void;
};

const TreatmentForm: FunctionComponent<TreatmentFormProps> = (props) => {
    const {treatment, hasError, isPending} = props;

    return (
        <>
            {props.children}
            <DatePicker
                label="Durchgeführt am"
                value={treatment.timestamp}
                onChange={props.onTimestampChange}
            />
            <TextField
                id="note-textarea"
                label="Notiz"
                placeholder="Notiz"
                value={treatment.note}
                onChange={props.onNoteChange}
                multiline
            />
            <FormControlLabel
                label={treatment.isPrivate ? 'Von Export exkludiert' : 'Im Export sichtbar'}
                control={
                    <Checkbox
                        icon={<HealthAndSafetyOutlined/>}
                        checkedIcon={<HealthAndSafety/>}
                        checked={treatment.isPrivate}
                        onChange={(ev) => props.onPrivateChange(ev.target.checked)}/>
                }/>

            <Stack direction="row" gap={2} justifyContent="flex-end">
                <Button className="tags-cancel-button"
                        variant="outlined"
                        color="primary"
                        onClick={props.onFormCancel}
                        disabled={isPending}>
                    Abbrechen
                </Button>
                <Button className="tags-save-button"
                        disabled={hasError || isPending}
                        variant="contained"
                        color="primary"
                        onClick={() => props.onFormSave(treatment)}>
                    Speichern
                </Button>
            </Stack>
        </>
    );
};

export default TreatmentForm;
